import CheckoutForm from './CheckoutForm.component';

export default CheckoutForm;